//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../Features/Features.StructureDesign.ContextAttributeBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../Features/Features.StructureDesign.FeatureSpreadsheetBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[1,"Attachment",0,"ScCollector",0],[1,"ContextAttribute",0,"Features.StructureDesign.ContextAttributeBuilder",0],[1,"MemberEndFace",0,"SelectNXObjectList",0],[0,"PadName",1,0],[0,"PositionType",1,0],[0,"ReverseXOffsetDirection",1,0],[0,"ReverseYOffsetDirection",1,0],[1,"RotateAngle",0,"Expression",0],[1,"StockData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0],[0,"ThicknessDirection",1,0],[1,"XOffset",0,"Expression",0],[1,"YOffset",0,"Expression",0]],[[["memberType"],"SetMemberType",{},1,0],[["matched"],"SetMatched",{},1,0],[[],"MatchMemberType",{R_:{success:''}},0,0],[[],"MatchMemberSize",{R_:{success:''}},0,0]],[]];
SPLM.Features.StructureDesign.PadBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.PadBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.PadBuilder.PositionTypes = Object.freeze({
    "Center" : "Center", "AlignToEdge" : "AlignToEdge"});

SPLM.Features.StructureDesign.PadBuilder.ThicknessDirections = Object.freeze({
    "AttachToEnd" : "AttachToEnd", "TrimBack" : "TrimBack", "TrimHalfThickness" : "TrimHalfThickness"});

export default SPLM;